import React from 'react';
import { Flex, Box } from 'grid-styled';
import { height, maxWidth } from 'styled-system';
import styled from 'styled-components';

export const List = styled(Flex)``;

List.defaultProps = {
    flexDirection: 'column'
};

export const Row = styled(Flex)`
    ${height};
    &:nth-child(odd) {
        background-color: ${p => p.theme.colors.gray[2]};
    }
`;

Row.defaultProps = {
    flex: '1',
    alignItems: 'center',
    height: 30
};

export const Cell = styled(Box)`
    ${maxWidth};
`;
Cell.propTypes = {
    ...maxWidth.propTypes
};
Cell.defaultProps = {
    flex: '1',
    p: 2
};

export const Label = styled(Cell)``;
Label.defaultProps = {
    maxWidth: 200
};

export const Value = styled(Cell)`
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: bold;
`;

export const LabelRow = ({ label, children }) => (
    <Row>
        <Label>{label}</Label>
        <Value>{children}</Value>
    </Row>
);

export const LabelRowAudio = ({ label, children }) => (
    <Row>
        <Label>{label}</Label>
        <audio controls src={children} type="audio/mpeg" />
    </Row>
);



// WEBPACK FOOTER //
// ./src/uic/list.js